/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ChapterCompletion } from './ChapterCompletion.js';
import {
    ChapterCompletionFromJSON,
    ChapterCompletionFromJSONTyped,
    ChapterCompletionToJSON,
} from './ChapterCompletion.js';
import type { Step } from './Step.js';
import {
    StepFromJSON,
    StepFromJSONTyped,
    StepToJSON,
} from './Step.js';

/**
 * 
 * @export
 * @interface ScriptSection
 */
export interface ScriptSection {
    /**
     * 
     * @type {number}
     * @memberof ScriptSection
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ScriptSection
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ScriptSection
     */
    description?: string;
    /**
     * 
     * @type {Array<Step>}
     * @memberof ScriptSection
     */
    steps?: Array<Step>;
    /**
     * 
     * @type {ChapterCompletion}
     * @memberof ScriptSection
     */
    completion?: ChapterCompletion;
    /**
     * 
     * @type {number}
     * @memberof ScriptSection
     */
    order?: number;
}

/**
 * Check if a given object implements the ScriptSection interface.
 */
export function instanceOfScriptSection(value: object): boolean {
    return true;
}

export function ScriptSectionFromJSON(json: any): ScriptSection {
    return ScriptSectionFromJSONTyped(json, false);
}

export function ScriptSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScriptSection {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'steps': json['steps'] == null ? undefined : ((json['steps'] as Array<any>).map(StepFromJSON)),
        'completion': json['completion'] == null ? undefined : ChapterCompletionFromJSON(json['completion']),
        'order': json['order'] == null ? undefined : json['order'],
    };
}

export function ScriptSectionToJSON(value?: ScriptSection | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'steps': value['steps'] == null ? undefined : ((value['steps'] as Array<any>).map(StepToJSON)),
        'completion': ChapterCompletionToJSON(value['completion']),
        'order': value['order'],
    };
}

